<template>
  <svg class="icon-search" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6.72916" cy="6.72916" r="5.87916" stroke-width="1.7"/>
    <line x1="11.473" y1="11.6167" x2="15.6542" y2="15.7979" stroke-width="1.7" stroke-linecap="round"/>
  </svg>
</template>

<script setup lang="ts">
</script>

<style lang="scss" >
.icon-search {
  stroke: var(--theme-icon-search-color);
  display: block;
  width:100%;
  height: 100%;
  fill:transparent !important;
  &--alternative {
    display: inline-block;
    stroke: var(--theme-colors-quaternary);
  }
}
</style>